import { Card, Inline, Skeleton, Stack } from '@cortex/ui';

export function NeedsAttentionSkeleton() {
  return (
    <Card>
      <Inline gap="sm" className="border-border border-b p-4">
        <Skeleton className="h-5 w-5 rounded-full" />
        <Skeleton className="h-[18px] w-[120px]" />
      </Inline>
      <Stack gap="none" className="divide-border divide-y">
        {Array.from({ length: 3 }).map((_, i) => (
          <Inline key={i} gap="sm" className="px-4 py-3">
            <Stack gap="none" className="min-w-0 flex-1">
              <Inline gap="sm">
                <Skeleton className="h-3 w-[30px]" />
                <Skeleton className="h-3.5 w-[60%]" />
              </Inline>
            </Stack>
            <Inline gap="sm">
              <Skeleton className="h-[22px] w-[60px]" />
              <Skeleton className="h-[22px] w-[50px]" />
            </Inline>
          </Inline>
        ))}
      </Stack>
    </Card>
  );
}
